import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { LandingPaths } from 'Feature/Common/Common/Constant/LandingPaths';
import { redirectToPaymentResultInConfrimWepod } from 'Feature/Orders/Common/Actions/Thunks/redirectToPaymentResultInConfrimWepod';
import Loader from 'Shared/Components/Loader/Loader';
import useAppDispatch from 'Shared/Store/dispatch/useAppDispatch';
import { useUserManager } from 'Shared/User/Hooks/useUserManager';

import { IRedirectToPaymentResultInConfrimWepodQuery } from 'Feature/Orders/Common/types/Queries/IRedirectToPaymentResultInConfrimWepodQuery';

const AutoLoginCallbackPage = () => {
  const { podLoginCallback } = useUserManager();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    podLoginCallback().then(async () => {
      const state = localStorage.getItem('AutoLoginState');
      const stateJson = state !== null ? JSON.parse(state) : null;

      if (stateJson?.invoice_status) {
        const query: IRedirectToPaymentResultInConfrimWepodQuery = {
          invoiceId: parseInt(stateJson.invoice_id),
        };
        dispatch(redirectToPaymentResultInConfrimWepod(query)).then((response: any) => {
          if (response && response?.payload) {
            navigate(
              `${LandingPaths.Landing.PaymentResult}/${encodeURIComponent(response.payload.orderId)}/${encodeURIComponent(response.payload.paymentId)}`
            );
          } else {
            navigate(`${LandingPaths.Landing.PaymentResult}`);
          }
        });
      } else {
        const a = document.createElement('a');
        a.href = '/';
        a.click();
      }
    });
  }, []);

  return <Loader active={true} />;
};
export default AutoLoginCallbackPage;
